import { isEmpty } from "lodash-es";
import {
  HoopsApi,
  ControlcenterMelcoModelsCreateHoop,
  useAPIAction,
} from "melco-shared-logic";
import { useCallback } from "react";

export interface editExistingHoopDraft {
  id: string;
  hoopDetail: ControlcenterMelcoModelsCreateHoop;
}

export const useEdithoop = () => {
  const [editHoop] = useAPIAction(
    HoopsApi,
    async (api, HoopDetail: any) => {
      //let payload = "";

      console.log(HoopDetail);

      HoopDetail = {
        ...HoopDetail,
        presser_foot:
          HoopDetail?.presser_foot && !isEmpty(HoopDetail.presser_foot)
            ? [HoopDetail.presser_foot].join(",")
            : "",
      };
      // call api
      let data = api.hoopsUpdate({
        id: HoopDetail.cloud_id,
        controlcenterMelcoModelsCreateHoop: HoopDetail,
      });
      return {
        data,
        successMessages: [],
      };
    },
    {
      skipErrorHandling: true,
      translationPrefix: "",
    }
  );

  return useCallback(
    async (HoopDetails: any) => {
      return await editHoop(HoopDetails);
    },
    [editHoop]
  );
};
